export class ErrorResponse {

  public message: string;

  public errorCode: number;


  constructor(message: string, errorCode: number) {
    this.message = message;
    this.errorCode = errorCode;
  }
}



// WEBPACK FOOTER //
// ./src/models/ErrorResponse.ts